import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const header = createSlice({
  name: 'header',
  initialState: {
    model: null,
    modelType: null,
    language: null,
    image: null,
    year: null
  },
  reducers: {
    SET_MODEL: (state, { payload = { brand, model, modelType, year, image, language } }) => {
      state.brand = payload.brand
      state.model = payload.model
      state.modelType = payload.modelType
      state.year = payload.year
      state.image = payload.image
      state.language = payload.language
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.header) {
        return {
          ...state,
          ...action.payload.header
        }
      }
      return state
    })
  }
})

export default header

export const headerActions = header.actions

export const headerSelectors = {
  selectModel: state => state.header
}
